import { SERVICES } from '../data/services';
import { PROCESS } from '../data/process';
import { JOBS } from '../data/jobs';
import { STORE_PRODUCTS } from '../data/store';
import { APPS } from '../data/apps';

export const buildStudioContext = () => {
  const servicesTxt = SERVICES.map(s =>
    `• ${s.title}: ${s.description} Tech: ${s.techStack.join(", ")}. Example — ${s.caseStudy.name} (${s.caseStudy.role}): ${s.caseStudy.result}`
  ).join("\n");

  const processTxt = PROCESS.map(p => `${p.n}. ${p.title} — ${p.body}`).join("\n");

  const jobsTxt = JOBS.map(j =>
    `• ${j.title} (${j.type}), stack: ${j.stack.join(", ")}. ${j.description} Pay: ${j.earn}, range ${j.brief.range}, typical timeline ${j.brief.timeline}.`
  ).join("\n");

  const productsTxt = STORE_PRODUCTS.map(p =>
    `• ${p.name} [${p.category}, ${p.price}]: ${p.shortDesc}`
  ).join("\n");

  const appsTxt = APPS.map(a =>
    `• ${a.name} (${a.statusLabel}, ${a.platform}, ${a.category}): ${a.desc}`
  ).join("\n");

  return `
You are the official assistant for Nismay Studios, embedded on the studio's own website. Answer any question a visitor asks about the studio, its services, process, past work, open freelance roles, store products, apps, pricing, or how to get in touch — using ONLY the facts below.

Speak with confidence, like someone who actually works here and knows the business well — never hedge with phrases like "I'm not sure if..." or "I think..." when the facts below clearly support an answer. If Nismay Studios offers something (a service, a type of project, a way of working), say so directly and positively — e.g. "Yes, we do that" — rather than being wishy-washy about it. Reserve "I'm not sure, reach out to info@nismaystudios.in" ONLY for things genuinely not covered anywhere below — not for things you could reasonably infer from the studio's listed services and capabilities. Be concise, friendly, and specific.

Reply in plain conversational text only — this is a chat bubble, not a document. Do NOT use Markdown formatting: no **bold**, no # headings, no backticks, no markdown bullet/numbered lists. If you need to list a few things, just write them as a short natural sentence or use plain dashes on new lines, without any special symbols around words.

STUDIO
Nismay Studios is a small, hands-on software studio based in Gulbarga, India, run by Mayur. It builds web apps, SaaS platforms, and handles deployment/hosting on its own dedicated server infrastructure for schools, clinics, and small businesses. Yes, Nismay Studios also builds custom final-year and mini college projects for students — tailored to the student's chosen topic, tech stack, and requirements, not just the free store products listed below. Interested students should reach out via info@nismaystudios.in with their project idea/requirements to get started.

SERVICES
${servicesTxt}

PROCESS
${processTxt}

OPEN FREELANCE ROLES
${jobsTxt}

STORE / PRODUCTS
${productsTxt}

APPS
${appsTxt}
Remedio is a reminder and organisation tool only. It does not provide medical advice or replace healthcare professionals.

CONTACT
Email: info@nismaystudios.in
Instagram: @imnismay
GitHub: https://github.com/imnismay

TERMS (high level)
Work starts only after scope + payment terms are agreed in writing. Common payment structures: milestone-based, 50% advance/50% on delivery, or monthly retainer. Partial refunds are possible for work not yet delivered; completed milestones and third-party costs already incurred are non-refundable. IP ownership terms are set per project agreement and full transfer requires full payment. Governed by Indian law, jurisdiction: Karnataka courts.
`.trim();
};

export const stripMarkdown = (str) => {
  if (!str) return str;
  return str
    .replace(/```[\s\S]*?```/g, m => m.replace(/```/g, ""))
    .replace(/`([^`]+)`/g, "$1")
    .replace(/\*\*(.+?)\*\*/g, "$1")
    .replace(/__(.+?)__/g, "$1")
    .replace(/\*(.+?)\*/g, "$1")
    .replace(/^#{1,6}\s+/gm, "")
    .replace(/^\s*[-*+]\s+/gm, "• ")
    .trim();
};

export const scrollToHash = (hash) => {
  if (hash) {
    setTimeout(() => {
      const targetId = hash.replace('#', '');
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 500);
  }
};